import { MoreOutlined } from "@ant-design/icons";
import { ReactNode } from "react";
import { Content, ContentCardWrapper, Title, TitleCn, TitleEn, TitleSeparator } from "./ContentCard.styled";
import { CSSProperties } from "styled-components";

interface ContentCardProps {
    titleCn: string,
    titleEn: string,
    style?: CSSProperties,
    children?: ReactNode[] | ReactNode,
}

let ContentCard: React.FC<ContentCardProps> = (props)=> {

    return <ContentCardWrapper style={props.style}>
        <Title>
            <TitleCn>{props.titleCn}</TitleCn>
            <TitleSeparator> {props.titleEn ? '/' : ''} </TitleSeparator>
            <TitleEn>{props.titleEn}</TitleEn>
            <div style={{flex: '1 1 auto'}} />
        </Title>
        
        <Content>
            {props.children}
        </Content>
    </ContentCardWrapper>
};

export default ContentCard;

